import {
    InputSearchBpl,
    OpenSearchType,
    SearchFieldsProducts,
    WildCardTitleSearchConnection,
} from 'src/types/schema/graphql'
import { useFilterStore } from '../../state/filterStore'
import { apiRequest, RequestInput } from 'src/api/apiRequest'
import searchBplProducts from '../queries/searchBplProducts'

export const getProducts = async (wildcardText: string) => {
    const {
        nextResultsOffset,
        styleFilter,
        brewTypeOptions,
        abvFilter,
        ibuFilter,
        srmFilter,
        availabilityFilter,
        stateFilter,
        setIsResultsLoading,
        setSearchResults,
        setNextResultsOffset,
        setTotalResults,
    } = useFilterStore.getState()

    const searchFieldsProducts: SearchFieldsProducts = {
        styleIds: styleFilter || null,
        brewTypes: brewTypeOptions || null,
        abvRange: abvFilter ? { min: abvFilter.min, max: abvFilter.max } : null,
        ibuRange: ibuFilter ? { min: ibuFilter.min, max: ibuFilter.max } : null,
        srmRange: srmFilter ? { min: srmFilter.min, max: srmFilter.max } : null,
        availabilities: availabilityFilter || null,
        state: stateFilter || null,
    }
    setIsResultsLoading(true)
    const input: RequestInput<InputSearchBpl> = {
        query: searchBplProducts,
        args: {
            input: {
                limit: 64,
                typeFilters: [OpenSearchType.Product],
                search: {
                    wildcardText,
                    searchFieldsProducts,
                },
                nextToken: nextResultsOffset,
            },
        },
        file: 'getProducts.ts',
        endpoint: 'searchBpl',
        publicQuery: true,
        noAlerts: true,
    }
    const { data } = await apiRequest<WildCardTitleSearchConnection, InputSearchBpl>(input)
    if (data) {
        setSearchResults(data?.items)
        setNextResultsOffset(data?.nextToken)
        setTotalResults(data?.totalResults)
    }
    setIsResultsLoading(false)
}
